import React from "react";
import Icon from "../components/ui/Icon";
import { useNavigate } from "react-router-dom";
import Button from "../components/ui/Button";

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 p-6">
      <div className="relative rounded-2xl p-8 shadow-2xl">
        {/* Icon with animation */}
        <div className="mb-6 flex justify-center animate-bounce">
          <div className="p-4 bg-gradient-to-t from-primary-light to-primary rounded-full shadow-lg">
            <Icon icon="lock" variant={"light"} />
          </div>
        </div>

        {/* Gradient text heading */}
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-l from-primary-light to-primary mb-4">
            Access Restricted
          </h1>
          <p className="font-display text-gray-600 mb-8 text-center">
            You don't have permission to access this resource. <br /> Please contact an administrator if you believe
            this is an error.
          </p>

          <div className="flex space-x-4 justify-center">
            <button
              className="m-2 px-4 py-2 rounded font-display font-semibold focus:outline-none bg-gradient-to-b from-primary-light to-primary text-white
              hover:bg-primary"
              onClick={() => navigate("/home")}
            >
              Return Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
